import logo from './logo.svg';
import './App.css';
import ContactForm from './ContactForm';
import './ContactForm.css'
function App() {
  return (
  <>
  <ContactForm/>
  
  
  </>
  );
}

export default App;
